import { TFloorParams, TRoomsParams } from 'common/types/floor-params.type';
import { hasMatchingDimensions } from '../../../common/helpers/has-matching-dimensions.helper';
import { hasMatchingArea } from '../../../common/helpers/has-matching-area.helper';
import { hasMatchingTypeInstallation } from '../../../common/helpers/has-matching-type-installation';

type TParams = {
  dataInRooms: TRoomsParams[];
  inputParams: TFloorParams;
  typeInstallation: string | null;
};

export const getRoomIdsWithSameInputParams = ({
  dataInRooms,
  inputParams,
  typeInstallation,
}: TParams): string[] => {
  const hasDimensions = inputParams?.length && inputParams?.width;

  const inputArea = inputParams?.areaUser ?? null;

  const sameRooms = dataInRooms.filter(item => {
    const itemLength = item.length ?? undefined;
    const itemWidth = item.width ?? undefined;
    const itemArea = item.square ?? null;
    const itemTypeInstallation = item.typeInstallation ?? null;
    const isTypeInstallationsEqual = hasMatchingTypeInstallation({ itemTypeInstallation, typeInstallation });

    if (hasDimensions) {
      return (
        isTypeInstallationsEqual &&
        hasMatchingDimensions(itemLength, itemWidth, inputParams?.length, inputParams?.width)
      );
    }

    return isTypeInstallationsEqual && hasMatchingArea(itemArea, inputArea);
  });

  return sameRooms.map(room => room.id);
};
